import type { ReminderStepRow } from '../types'
import { formatDate } from '../utils/helpers'
import StatusBadge from './StatusBadge'

interface Props {
  steps: ReminderStepRow[]
}

export default function ReminderTimeline({ steps }: Props) {
  const ordered = [...steps].sort((a, b) => a.step_number - b.step_number)

  return (
    <div className="space-y-5">
      <h3 className="text-sm font-medium text-ica-text-secondary">Reminder schedule</h3>
      <div className="relative space-y-6 pl-5">
        <div className="absolute left-[0.45rem] top-2 bottom-2 w-px bg-ica-border" />
        {ordered.map((step) => (
          <div key={step.id} className="relative flex items-start gap-3">
            <div
              className={`mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full border-2 ${
                step.status === 'sent'
                  ? 'border-ica-green bg-ica-green'
                  : step.status === 'scheduled'
                    ? 'border-ica-accent bg-ica-bg'
                    : step.status === 'skipped'
                      ? 'border-ica-text-muted bg-ica-text-muted/50'
                      : 'border-ica-red bg-ica-red'
              }`}
            />
            <div className="flex-1 space-y-1">
              <p className="text-sm font-medium">{step.subject}</p>
              <p className="text-xs text-ica-text-muted">{formatDate(step.scheduled_for)}</p>
              <StatusBadge status={step.status} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
